const GuestSelect = {
    baseStyle: {
        _focus: {
            borderColor: 'black',
            boxShadow: '0px 0px 8px 0px #BBC1CA',
            outline: 'none',
        },
        _focusWithin: {
            borderColor: 'black',
        },
        _hover: {
            borderColor: 'black',
        },
        backgroundColor: 'white',
        borderColor: 'neutral.500',
        borderRadius: 'full',
        borderWidth: '1px',
        paddingBottom: '3px',
    },
    defaultProps: {
        size: 'sm',
    },
    sizes: {
        lg: {
            fontSize: 'lg',
            fontWeight: 500,
            h: '48px',
            minW: '80px',
        },
        md: {
            fontSize: 'md',
            fontWeight: 500,
            h: '40px',
            minW: '76px',
        },
        sm: {
            fontSize: 'sm',
            fontWeight: 500,
            h: '32px',
            minW: '72px',
        },
    },
};
export default GuestSelect;
